import moment from "moment";

/**
 * Formats date to UI.
 * @param {string} dateString The date to be formatted
 * @returns {string} The formatted date
 */
export function formatDate(dateString) {
  return dateString ? moment(dateString).format("YYYY-MM-DD") : "";
}

// https://www.freecodecamp.org/news/how-to-validate-a-date-in-javascript
/**
 * Checks if it's a valid date string or object.
 * @param {(string|Date)} rawDate The date to be checked
 * @returns {boolean} The result of the check
 */
export function isDateValid(rawDate) {
  return !isNaN(new Date(rawDate));
}

/**
 * Returns browser local string without seconds like "2024-09-12T14:35".
 * @param {Date} dateObj The date object
 * @returns {string} The local date string
 */
export function dateToLocalIsoString(dateObj) {
  return new Date(`${dateObj.toString().split("GMT")[0]} UTC`).toISOString().slice(0, -8);
}

/**
 * Returns UTC date string ready to save in back-end like "2024-09-12T17:35:00Z".
 * @param {Date} dateObj The date object
 * @returns {string} The DB ready UTC date string
 */
export function dateToDbUtcIsoString(dateObj) {
  return `${dateObj.toISOString().slice(0, -5)}Z`;
}
